import React from "react";
import ReactPaginate from "react-paginate";
import { handlePageClick } from "../Components/Hooks/useFunctions";
import { useHistory, useLocation } from "react-router-dom";

const Pagination = ({ data }) => {
  const history = useHistory();
  const location = useLocation();

  // Get full pathname (e.g., "/audios/.../bayanat/&recorded_year=1997&duration=40-60(minutes)")
  const fullPath = location.pathname;

  // Extract from first '&'
  const queryStartIndex = fullPath.indexOf('&');
  const rawParams = queryStartIndex !== -1 ? fullPath.substring(queryStartIndex) : "";

  const handlePageClick = (index) => {
    const page = index.selected + 1;
  
    // Clean up existing page params from rawParams
    const rawQuery = rawParams.startsWith("&") ? rawParams.substring(1) : rawParams;
    const params = new URLSearchParams(rawQuery);
  
    // Remove old page param(s)
    params.delete("page");
  
    // Add new page
    params.set("page", page);
  
    // Push updated URL
    history.push(`&${params.toString()}`);
  };

  return (
    <div className="pagination">
      <ReactPaginate
        breakLabel="..."
        nextLabel="››"
        previousLabel="‹‹"
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        marginPagesDisplayed={2}
        forcePage={Math.ceil(data.current_page_number - 1)}
        pageCount={Math.ceil(data.total_pages)}
      />
    </div>
  );
};

export default Pagination;
